<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f">
        <div class="pagetitle">{{ $t('plugin.train.filterTitle') }}</div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline searchform">
          <div class="flex mar_t20 mar_b20">
            <el-form-item :label="$t('plugin.train.place')" class="mar_l20">
              <el-input v-model="formInline.name" size="medium" :placeholder="$t('plugin.train.placePh')" @input="fetchData"></el-input>
            </el-form-item>
            <el-form-item :label="$t('plugin.train.type')">
              <el-select v-model="formInline.type" :placeholder="$t('common.pleaseSelect')" @change="fetchData">
                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="ba_f mar_t20 pad_20">
        <div class="pagetitle mar_b20">{{ $t('plugin.train.title') }}</div>
        <div class="t_l mar_b20">
          <el-button type="primary" size="medium" @click="handleEdit(false)">{{ $t('plugin.train.addPlace') }}</el-button>
        </div>
        <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" :label="$t('common.sort')" width="55"></el-table-column>
          <el-table-column prop="name" :label="$t('plugin.train.name')" width="100px"></el-table-column>
          <el-table-column prop="address" :label="$t('plugin.train.address')"></el-table-column>
          <el-table-column prop="tel" :label="$t('plugin.train.contact')" align="center"></el-table-column>
          <el-table-column prop="createdAt" :label="$t('plugin.train.trainDate')" align="center"></el-table-column>
          <el-table-column :label="$t('plugin.train.trainTime')" align="center">
            <template slot-scope="scope">
              <div v-for="(item, index) of scope.row.timeData" :key="index">
                <span>{{ item.startAt }}</span>
                <span>~</span>
                <span>{{ item.endAt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('plugin.train.enrollLimit')" align="center">
            <template slot-scope="scope">
              <div>
                <span style="color: #2a75ed;">{{ scope.row.people }}</span>
                <span>/</span>
                <span style="color: #67c23a;">{{ scope.row.enrollNum }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('plugin.train.displayStatus')" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.display" active-color="#2A75ED" inactive-color="#999" @change="handchangeState($event, scope.row.id)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="handleSeeDetail(scope.row)">{{ $t('common.view') }}</el-button>
              <el-button type="text" @click="handleEdit(scope.row.id)">{{ $t('common.edit') }}</el-button>
              <el-button type="text" @click="handleDelete(scope.row)">{{ $t('common.delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.pagesize" :current-page.sync="formInline.page" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <train-edit ref="trainEdit" v-if="dialogVisible" :options="typeOptions" @callback="callback"></train-edit>
  </div>
</template>
<script>
import TrainEdit from './components/trainEdit.vue';
import { trainList, trainDelete } from '@/api/plugins';
export default {
  components: { TrainEdit },
  data() {
    return {
      dialogVisible: false,
      formInline: {
        page: 1,
        name: '',
        type: '',
        getCity: '',
      },
      listLoading: true,
      list: [],
      selectRows: '',
      page: {
        total: 0,
        pagesize: 10,
        currentPage: 1,
      },
    };
  },
  computed: {
    typeOptions() {
      return [
        { value: '', label: this.$t('plugin.train.typeAll') },
        { value: 1, label: this.$t('plugin.train.typeEntry') },
        { value: 2, label: this.$t('plugin.train.typeFull') },
        { value: 0, label: this.$t('plugin.train.typeOther') },
      ];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    callback() {
      this.dialogVisible = false;
      this.fetchData();
    },
    setSelectRows(val) {
      this.selectRows = val;
    },
    fetchData() {
      trainList(this.formInline).then((res) => {
        if (res.code == 1) {
          this.list = (res.data || []).map((item) => {
            item.display = item.display == '1';
            return item;
          });
          this.page.total = res.count;
          this.listLoading = false;
        }
      });
    },
    handleEdit(id = false) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.trainEdit.init(id);
      });
    },
    handleDelete(row) {
      if (row.id) {
        this.$baseConfirm(this.$t('confirm.deleteItem'), null, async () => {
          const { msg } = await trainDelete({ id: row.id });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      }
    },
    handleSeeDetail(row) {
      this.$router.push({ path: '/appointment', query: { id: row.id } });
    },
    handleCurrentChange(val) {
      this.formInline.page = val;
      this.fetchData();
    },
    handchangeState(msg, id) {
      trainDelete({ id, type: 'display', display: msg ? '1' : '2' }).then((res) => {
        if (res.code == 1) this.fetchData();
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.input-w {
  width: 200px;
  margin-right: 15px;
}
</style>
